import React, { useState } from 'react';
import { Share2 } from 'lucide-react';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { Button } from '@dashboard/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@dashboard/components/ui/tooltip';
import {
  getLinkInBioSharedUrl,
  getLinkInBioShortUrl,
  LINK_IN_BIO_SELLER_VISIT,
  withLinkInBioQuery,
} from '@dashboard/services/getLinkInBioUrl';
import LinkInBioShareDialog from './LinkInBioShareDialog';

export default function LinkInBioShareButton({ disabled = false }: { disabled?: boolean }) {
  const { seller } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const shortUrl = getLinkInBioShortUrl(seller);
  const url = getLinkInBioSharedUrl(seller);
  if (!shortUrl || !url) return null;

  const button = (
    <Button type="button" variant="outline" disabled={disabled} onClick={() => setIsOpen(true)}>
      <Share2 />
      Share
    </Button>
  );

  if (disabled) {
    return (
      <TooltipProvider>
        <Tooltip>
          {/* A disabled button fires no pointer events, so the trigger needs a wrapper. */}
          <TooltipTrigger asChild>
            <span className="inline-flex" tabIndex={0}>
              {button}
            </span>
          </TooltipTrigger>
          <TooltipContent>Publish your link in bio to share it</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <>
      {button}
      <LinkInBioShareDialog
        url={url}
        openUrl={withLinkInBioQuery(url, LINK_IN_BIO_SELLER_VISIT)}
        qrUrl={withLinkInBioQuery(shortUrl, { utm_source: 'qr' })}
        fileName={`${seller.name}-link-in-bio-qr`}
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  );
}
